/**
 * External dependencies
 */
import React from "react";
import { Popover as BasePopover } from "react-tiny-popover";
import { omit } from "lodash";

/**
 * Style dependencies
 */
import "./styles.scss";

const Popover = ({
  showArrow = true,
  preferPlace = "below",
  enterExitTransitionDurationMs = 0,
  ...props
}) => {
  return (
    <BasePopover
      enterExitTransitionDurationMs={enterExitTransitionDurationMs}
      isOpen={props.isOpen}
      positions={["bottom"]}
      onClickOutside={props.onOuterAction}
      windowBorderPadding={20}
      disableReposition={true}
      showArrow={showArrow}
      preferPlace={props.align}
      content={
        props.isOpen ? (
          <div className="popover__content">{props.content}</div>
        ) : null
      }
      {...omit(props, ["content", "ref"])}
    >
      {props.children}
    </BasePopover>
  );
};

export default Popover;
